import React, { useEffect, useRef, useState } from "react";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, CircularProgress } from "@mui/material";
import MailIcon from '@mui/icons-material/Mail';
import UnassignDeviceModal from "./unassigndevicemodal";
const EditPatient = ({ type, isOpen, close ,setToastMessage ,selectedCard,setToastSeverity,setOpenToast}) => {
  const [devicesData, setDevicesData] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
const[fetchload,setFetchLoad]=useState(false)
  const [serialNumber, setSerialNumber] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const[isloading,setIsLoading]=useState(false)
  const [deviceType, setDeviceType] = useState("");
  const [details, setDetails] = useState("");
  const [currentpatient,setCurrentPatient]=useState('')
  const [confirmUnassignOpen, setConfirmUnassignOpen] = useState(false);
const[gettingdevices,setGettingDevices]=useState(false)
    const userConfig = useSelector((state) => state.userconfig);
  const practiseid = window.getPracticeId();
const [selectedDeviceId, setSelectedDeviceId] = useState("");
    const [manualEntry, setManualEntry] = useState(false);
  const loginUser = localStorage.getItem("user");
const deviceTypes = [
  { label: "BPP", value: "bpp" },
  { label: "CGM", value: "cgm" },
  { label: "CPAP", value: "cpap" },
  { label: "WLM", value: "wlm" },
  { label: "EKG", value: "ekg" },
];
const [adddevicemodal,setAddDevicemodal]=useState(false)
  // useEffect(() => {
  //   if (isOpen) {
  //     fetchDevices();
  //   }
 
  // }, [isOpen]);
 
  const fetchDevices = async () => {
  //  setLoading(true); // Set loading to true before fetching data
  setGettingDevices(true)
    try {
      const response = await api.get(`/v1/${practiseid}/rpm/devices`);
      if (response.status === 200) {
        setDevicesData(response.data);
      }
    } catch (error) {
      console.error("Error fetching devices:", error);
    } finally {
      setGettingDevices(false); // Set loading to false after data is fetched
    }
  };
 
  const [formData, setFormData] = useState({
    patientid:"",
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    email: "",
    phone: "",
    reminders: "",
    devices: {
      bpp: "",
      cgm: "",
      cpap: "",
      wlm: "",
      ekg: "",
    },
    devicesstate: {
      bpp: false,
      cgm: false,
      cpap: false,
      wlm: false,
      ekg: false,
    },
  });
  const [searchResultStatus, setSearchResultStatus] = useState(null);
const handlecleardata=()=>{
    setFormData({
        patientid:"",
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        email: "",
        phone: "",
        reminders: "",
        devices: {
          bpp: "",
          cgm: "",
          cpap: "",
          wlm: "",
          ekg: "",
        },
        devicesstate: {
          bpp: false,
          cgm: false,
          cpap: false,
          wlm: false,
          ekg: false,
        },
      })
      setCurrentPatient('')
}
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
 
 

  const handleDevicestateChange = (device, value) => {
    setFormData((prev) => ({
      ...prev,
      devicesstate: { ...prev.devicesstate, [device]: value }, // Update devicesstate, not devices
    }));
  };
  const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";

  const parts = dateStr.split("-");
  if (parts.length !== 3) return "";

  const year = parts[0];
  const month = parts[1].padStart(2, "0");
  const day = parts[2].padStart(2, "0");

  return `${year}-${month}-${day}`;
};

  
  const handlesearch = async (value) => {
    if(!value){
        return
    }
    try {
        setFetchLoad(true)
        const response = await api.get(`/v1/${practiseid}/patient/${value}/rpm/get-patient`);
        fetchDevices();
        if (response?.data?.rpm?.length) {
            const patient = response.data?.rpm.find((x) =>x.patientid == value);

            setCurrentPatient(patient)
            // map devices from API
const deviceMap = {
  bpp: "",
  cgm: "",
  cpap: "",
  wlm: "",
  ekg: "",
};

// if (patient.devices?.length) {
//   patient.devices.forEach((d) => {
//     if (d.devicetype && deviceMap.hasOwnProperty(d.devicetype)) {
//       deviceMap[d.devicetype] = d.devicedetails;
//     }
//   });
// }
let selectedIdFromAPI = "";

if (patient.devices?.length) {
  patient.devices.forEach((d) => {
    if (d.devicetype && deviceMap.hasOwnProperty(d.devicetype)) {
      deviceMap[d.devicetype] = d.serialnumber || d.devicedetails;

      // 👇 IMPORTANT: set dropdown selected id
      selectedIdFromAPI = d.id;
    }
  });
}



// 👇 set dropdown value
setSelectedDeviceId(selectedIdFromAPI);


   console.log(patient,'filter')
            if (patient.patientid) {
            const result = {
        patientid: patient.patientid,
        firstName: patient.firstname || "",
        lastName: patient.lastname || "",
        email: patient.email || "",
        phone: patient.phone || "",
        dob: patient.dob ?formatDateForInput(patient.dob): "",
        gender: patient.gender === "m" ? "Male" : "Female",
        reminders: patient.reminder === 1 ? "enable" : "disable",
  devices: deviceMap,
        devicesstate: {
          bpp: patient.bpp === "Y",
          cgm: patient.cgm === "Y",
          cpap: patient.cpap === "Y",
          wlm: patient.wlm === "Y",
          ekg: patient.ekg === "Y",
        },
      };
  

                setFormData((prev) => ({ ...prev, ...result}));
            } else {
                setSearchResultStatus(201);
                console.log("No matching patient found.");
                return null;
            }
        } else {
            setSearchResultStatus(201);
            console.log("Invalid response data.");
            return null;
        }
    } catch (error) {
        console.error("Error occurred while fetching patient data:", error);
        throw error;
    }finally{
        setFetchLoad(false)
    }
};
useEffect(()=>{
if(selectedCard.patientid&&isOpen){
handlesearch(selectedCard.patientid)
}
},[isOpen])
  const handleDeviceChange = (e) => {
  const selectedId = e.target.value;
   setSelectedDeviceId(selectedId);
  if (!selectedId) return;

  const selectedDevice = devicesData.find(
    (d) => String(d.id) === String(selectedId)
  );

  if (!selectedDevice) return;

  const deviceType = selectedDevice.devicetype?.toLowerCase(); // case-insensitive
  const serialNumber = selectedDevice.deviceserialnumber;

  setFormData((prev) => ({
    ...prev,
    devicesstate: {
      ...prev.devicesstate,
      [deviceType]: true, // make the selected device true
    },
    devices: {
      ...prev.devices,
      [deviceType]: serialNumber, // set serial number
    },
  }));
};
  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!formData.email) {
        setToastMessage('Email is required!');
        setToastSeverity('error');
        setOpenToast(true);
        return;
    }
    if (!formData.patientid) {
        setToastMessage('Patient ID is required!');
        setToastSeverity('error');
        setOpenToast(true);
        return;
    }
    if (!formData.firstName || !formData.lastName) {
        setToastMessage("First name and last name are required!");
        setToastSeverity('error');
        setOpenToast(true);
        return;
    }
try {
  const response = await api.put(`/v1/${practiseid}/patient/${selectedCard?.patientid}/rpm/rpm-patient`,{
 "rowid":selectedCard?.id,
    "chartid":formData.patientid,
    "firstname": formData.firstName,
    "lastname": formData.lastName,
    "gender": formData.gender==='Male'?'m':"f",
    "dob": formData.dob,
    bpp: formData.devicesstate.bpp ? "Y" : "N",
    cgm: formData.devicesstate.cgm ? "Y" : "N",
    cpap: formData.devicesstate.cpap ? "Y" : "N",
    wlm: formData.devicesstate.wlm ? "Y" : "N",
    ekg: formData.devicesstate.ekg ? "Y" : "N",
    "email": formData.email,
    "phone": formData.phone,
    "subscription": Object.keys(formData?.devicesstate).filter((key) => formData?.devicesstate[key]),
    bpp_device: formData.devices.bpp || "",
    cgm_device: formData.devices.cgm || "",
    cpap_device: formData.devices.cpap || "",
    wlm_device: formData.devices.wlm || "",
    ekg_device: formData.devices.ekg || "",        
    "created_by": `${formData?.firstName} ${formData?.lastName}`,
    "reminder": formData.reminders==='enable'?1:0,
 
  })
  if (response.status === 200) {
    setToastMessage(response.message);
    setToastSeverity('success');
    setOpenToast(true);
 
    setTimeout(() => close(false), 2000);
  }else{
    setToastMessage(response.message);
    setToastSeverity('info');
    setOpenToast(true);
  }
} catch (error) {
  setToastMessage('Something went wrong');
  setToastSeverity('error');
  setOpenToast(true);
}
  };

  
  
const generateEmail = async () => {
  try {
    setLoading(true);
    const emailresp = await api.post(
      `/v1/${practiseid}/rpm/email/create-alias`
    );

    const email =
      emailresp?.data?.newemail ||
      formData.email || "";

    setFormData((prev) => ({
      ...prev,
      email
    }));
    setDeviceNumber(email);
    setLoading(false);
  } catch (error) {
    console.error("Error generating email:", error);
      setToastMessage('Error generating email');
      setToastSeverity('error');
      setOpenToast(true);
      setLoading(false);
  }
};

const addDevice = async () => {
  if (!serialNumber?.trim()) {
    setToastMessage("Serial Number is required!");
    setToastSeverity("error");
    setOpenToast(true);
    return;
  }

  if (!deviceType?.trim()) {
    setToastMessage("Device Type is required!");
    setToastSeverity("error");
    setOpenToast(true);
    return;
  }

  if (!deviceNumber?.trim()) {
    setToastMessage("Device Number is required!");
    setToastSeverity("error");
    setOpenToast(true);
    return;
  }
  try {
    const response = await api.post(`/v1/${practiseid}/rpm_devices/create_device`, {
      devicesno: serialNumber,
      devicetype: deviceType,
      created_by: loginUser,
      devicedtls: details,
      deviceno: deviceNumber,
      practiceid: practiseid
    });

    if (response.status === 200) {

      const newDevice = response.data;

      setToastMessage(response.message || "Device added successfully.");
      setToastSeverity("success");
      setOpenToast(true);

      setAddDevicemodal(false);

      await fetchDevices();

      if (newDevice?.id) {
        setSelectedDeviceId(newDevice.id);

        setFormData((prev) => ({
          ...prev,
          devicesstate: {
            ...prev.devicesstate,
            [deviceType]: true,
          },
          devices: {
            ...prev.devices,
            [deviceType]: serialNumber,
          },
        }));
      }
    }
  } catch (error) {
    console.error("Error adding device:", error);
  }
};


const unassigndevice = async () => {
  try {
    setIsLoading(true);
console.log(currentpatient,'curreee')
    // find selected device from dropdown

    const device=currentpatient?.devices[0]
  

    if (!device.serialnumber) {
      setToastMessage("No device selected to unassign");
      setToastSeverity("info");
      setOpenToast(true);
      setIsLoading(false);
      return;
    }

    const payload = {
      devicesno: device.serialnumber, // serial number
      devicetype:device.devicetype,        // bpp/cgm/cpap
      created_by: userConfig?.username,
    };

    const response = await api.put(
      `v1/${practiseid}/patient/${selectedCard?.patientid}/rpm/device-unassign`,
      payload
    );

    if (response.status === 200) {
      setToastMessage("Device un-assigned successfully");
      setToastSeverity("success");
      setOpenToast(true);
    }
  } catch (error) {
    console.log(error);
    setToastMessage("Failed to unassign device");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsLoading(false);
    handlesearch(selectedCard.patientid);
  }
};

const isDeviceAssigned = currentpatient?.devices?.length > 0; 

const hasAssignedDevice = currentpatient?.devices?.length > 0;

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-auto overflow-scroll custom-scrollbar" style={{scrollbarWidth:'none'}}>
          <div className="bg-white rounded-lg shadow-lg  md:max-w-[50%] w-[90%] ">
            {/* Modal Header */}
            <div className="flex justify-between items-center border-b p-3 bg-[#E179544A]">
              <h2 className="text-[16px] font-semibold text-[black]">{adddevicemodal?"ADD DEVICE":"EDIT PATIENT"}
              </h2>
              <button
                onClick={() => {
                  if(adddevicemodal){
                    setAddDevicemodal(false)
                    return
                  }
                    handlecleardata()
                    close(false)}}
                className="text-gray-500 hover:text-gray-700  "
              >
                <CloseIcon style={{width:"22px"}}/>
              </button>
            </div>
 
            {/* Modal Content */}
           {!adddevicemodal?<div className="p-4">
              {loading&&fetchload? (
                <div className="flex justify-center items-center py-6">
   <div class="w-8 h-8 border-4 border-t-transparent border-blue-500 border-solid rounded-full animate-spin"></div>

                </div>
              ) : (
                <form onSubmit={handleSubmit}>
         <div className="flex justify-center items-center w-full mb-2">
  <div className="relative w-full">
    <input
      type="text"
      value={selectedCard?.patientid}
      disabled
   
      className="w-full p-1 px-1  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
    <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 18a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35" />
      </svg>
    </span>
  </div>
</div>
<div className="w-full flex justify-between py-2">
  <div className="font-semibold  text-16px">Manual Entry</div>
  <div> 
  <div class="flex items-center space-x-4">
  <label for="toggle" class="relative inline-block w-10 h-6">
    <input onChange={() => setManualEntry(!manualEntry)} checked={manualEntry} type="checkbox" id="toggle" class="absolute opacity-0 w-0 h-0 peer" />
    <span class="block w-full h-full bg-gray-300 rounded-full cursor-pointer peer-checked:bg-orange-500 transition-all"></span>
    <span class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all peer-checked:translate-x-4"></span>
  </label>
  </div>
</div>
</div>
 
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2">
                    {/* First Name */}
                    <div >
                      <label className="block text-gray-700 text-[14px] font-medium mb-2 text-left">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter first name"
                      />
                    </div>
 
                    {/* Last Name */}
                    <div>
                      <label className="block text-gray-700 text-[14px] font-medium mb-2 text-left">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter last name"
                      />
                    </div>
 
                    {/* Gender */}
                    <div>
                      <label className="block text-gray-700 text-[14px] font-medium mb-2 text-left">
                        Gender
                      </label>
                      <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
 
                    {/* Date of Birth */}
                    <div>
                      <label className="block text-gray-700 text-[14px] font-medium mb-2 text-left">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="dob"
                        value={formData.dob}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                      />
                    </div>
 
                    {/* Email */}
                    <div>
            {/* Label + Icon */}
            <div className="flex items-center justify-between mb-2">
              <label className="text-gray-700 font-medium" htmlFor="email">
                Email
              </label>
              {!formData.email && (
                <button
                  type="button"
                  onClick={generateEmail}
                  className="flex items-center gap-1 px-2 py-1 rounded-sm bg-[#D97842] text-white text-xs hover:bg-[#c86a3a] disabled:opacity-50 disabled:cursor-not-allowed"
                  title="Generate Email"
                  disabled={!formData.firstName || !formData.lastName}
                >
                  <MailIcon size={10} /> Generate Email
                </button>
              )}
            </div>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter email address"
                      />
                    </div>
 
                    {/* Phone */}
                    <div>
                      <label className="block text-gray-700 text-[14px] font-medium mb-2 text-left">
                        Phone
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        disabled={!manualEntry}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter phone number"
                      />
                    </div>
 
                    {/* Send Reminders */}
                    <div className="sm:col-span-2">
                      <label className="block text-gray-700 text-[14px] font-medium mb-2 text-left">
                        Send Reminders
                      </label>
                      <div className="flex items-center space-x-4">
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="reminders"
                            value="enable"
                            disabled={!manualEntry}
                            checked={formData.reminders === "enable"}
                            onChange={handleChange}
                            className="mr-2"
                          />
                          Enable
                        </label>
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="reminders"
                            value="disable"
                            disabled={!manualEntry}
                            checked={formData.reminders === "disable"}
                            onChange={handleChange}
                            className="mr-2"
                          />
                          Disable
                        </label>
                      </div>
                    </div>
 
                    {/* RPM Types */}
                    <div className="sm:col-span-2">
                      <label className="block text-[14px] text-gray-700 font-medium mb-2 text-left">
                        BPM :
                      </label>
                
                <div className="flex gap-2 w-full">
                     
                        <div className="flex-1"> 
{formData.devicesstate ? (
 (!currentpatient?.devices?.length > 0 && gettingdevices) ? (
    <div className="w-full px-4 py-2 border rounded-md bg-gray-100 text-sm text-gray-500">
      Getting devices...
    </div>
  ) : currentpatient?.devices?.length > 0 ? (
    <input
      type="text"
      value={currentpatient?.devices?.[0]?.devicetype || ""}
      disabled
      className="w-full px-4 py-2 border rounded-md bg-gray-100"
    />
  ) : (
    <select
      disabled={!manualEntry}
      onChange={handleDeviceChange}
      value={selectedDeviceId}
      className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
    >
      <option value="">Select Device</option>
      {devicesData
        .filter((x) => x.devicetype)
        .map((deviceOption) => (
          <option key={deviceOption.id} value={deviceOption.id}>
            {deviceOption.deviceno} - {deviceOption.deviceserialnumber} - {deviceOption.devicetype}
          </option>
        ))}
    </select>
  )
) : null}


</div>   

                         
{formData.devicesstate && (
  hasAssignedDevice ? (
    <button
      type="button"
   onClick={() => setConfirmUnassignOpen(true)}

      disabled={isloading}
      className="px-2 py-2 bg-red-100 text-red-700 rounded-md border border-red-300 w-[200px]"
    >
      {isloading ? "Unassigning..." : "Unassign Device"}
    </button>
  ) : devicesData?.length > 0 ? (
    <button
      type="button"
      onClick={() => setAddDevicemodal(true)}
      className="px-2 py-2 bg-[#FEFCE8] text-[#A16207] rounded-md border-[1.2px] border-[#ccc] w-[200px]"
    >
      + Add Device
    </button>
  ) : null
)}



                </div>
                        
                   
                   
                    </div>
 
               
                  </div>
                  <div className="flex w-[100%] gap-2">
  
   
                    </div>
                  {/* Modal Footer */}
                  <div className="flex justify-end  p-4">
                    <button
                      onClick={() => {
                        handlecleardata()
                        close(false)}}
                      className="px-4 py-2 border-[1.5px] border-[#E4E4E7] text-black bg-[#FFF] rounded-md hover:bg-red-600 hover:text-[white] mr-2"
                    >
                      Close
                    </button>
                    <button
  type="submit"
  className={`px-4 py-2 rounded-md ${false  ? 'bg-gray-500 cursor-not-allowed' : 'bg-[#F97316] text-white'}`}
 
>
  Save
</button>
 
 
                  </div>
                </form>
              )}
            </div>:<div className="p-4">
           
            <form className="grid grid-cols-2 gap-4 mt-4 text-start">
            {/* Serial No */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Serial No
              </label>
              <input
                type="text"
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                placeholder="Enter Serial No"
                value={serialNumber}
                onChange={(e) => setSerialNumber(e.target.value)}
              />
            </div>
 
            {/* Device No */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Device No
              </label>
              <input
                type="text"
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                placeholder="Enter Device No"
                value={deviceNumber}
                onChange={(e) => setDeviceNumber(e.target.value)}
              />
            </div>
 
            {/* Type (Dropdown) */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Type
              </label>
              <select
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                value={deviceType}
                onChange={(e) => setDeviceType(e.target.value)}
              >
                <option value="" disabled>
                  Select Type
                </option>
                {deviceTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
 
            {/* Details */}
            <div className="d-none">
              <label className="block text-sm font-medium text-gray-700">
                Details
              </label>
              <input
                type="text"
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                placeholder="Enter Details"
                value={details}
                onChange={(e) => setDetails(e.target.value)}
              />
            </div>
          </form>
          <div className="flex justify-end mt-6 space-x-2">
            <button
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
              onClick={() =>setAddDevicemodal(false)}
            >
              Close
            </button>
            <button onClick={()=>addDevice()}
              className="px-4 py-2 bg-[#E17954] text-white rounded-md hover:bg-blue-600"
         
            >
              Save
            </button>
          </div>
            </div>}
          </div>
        </div>
      )}
{/* {confirmUnassignOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center">

 
    <div
      className="absolute inset-0 bg-black/40 backdrop-blur-[1px]"
      onClick={() => setConfirmUnassignOpen(false)}
    />


    <div className="relative z-10 w-full max-w-sm rounded-lg text-start bg-white shadow-lg">

 
      <div className="px-4 py-3 border-b flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-900">
          Unassign device
        </h2>

        <button
          onClick={() => setConfirmUnassignOpen(false)}
          className="text-gray-400 hover:text-gray-700 text-lg leading-none"
        >
          ×
        </button>
      </div>

      <div className="px-4 py-3 text-sm text-gray-600">
        Remove this device from patient?
      </div>

   
      <div className="px-4 py-3 border-t flex justify-end gap-2">
        <button
          onClick={() => setConfirmUnassignOpen(false)}
          className="px-3 py-1.5 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>

        <button
          disabled={isloading}
          onClick={async () => {
            await unassigndevice();
            setConfirmUnassignOpen(false);
          }}
          className="px-3 py-1.5 text-sm rounded-md bg-red-500 text-white hover:bg-red-600 disabled:opacity-50"
        >
          {isloading ? "Unassigning..." : "Unassign"}
        </button>
      </div>
    </div>
  </div>
)} */}
<UnassignDeviceModal
  open={confirmUnassignOpen}
  loading={isloading}
  onClose={() => setConfirmUnassignOpen(false)}
  onConfirm={async () => {
    await unassigndevice();
    setConfirmUnassignOpen(false);
  }}
/>


        <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
    </>
  );
};
 
export default EditPatient;